// Monaco setup MUST be imported first to configure workers before any Monaco usage
import './utils/monaco-setup';
// GSAP PixiPlugin registration — must be imported before any GSAP-to-PixiJS animations
import './pixi/gsapPixiSetup';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
